"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vietnam = function () { return (React.createElement("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
    React.createElement("g", { transform: "translate(5.000000, 5.000000)" },
        React.createElement("circle", { fill: "#DA251D", cx: "45", cy: "45", r: "45" }),
        React.createElement("polygon", { fill: "#FFFF00", points: "45 55.7551292 33.2333333 62.9116791 37.7387717 49.5292916 25.9666667 40.5783457 40.5123141 39.4556748 45 27.0883209 49.4876859 39.4556748 64.0333333 40.5783457 52.2612283 49.5292916 56.6796835 62.7659348" })))); };
exports.default = vietnam;
//# sourceMappingURL=vi-VN.js.map